import { createContext, useContext, ReactNode } from 'react';
import { useCentralizedMobileDetection, CentralizedMobileDetection } from '@/hooks/useCentralizedMobileDetection';

const MobileDetectionContext = createContext<CentralizedMobileDetection | undefined>(undefined);

export interface MobileDetectionProviderProps {
  children: ReactNode;
}

export const MobileDetectionProvider = ({ children }: MobileDetectionProviderProps) => {
  const detection = useCentralizedMobileDetection();
  
  return (
    <MobileDetectionContext.Provider value={detection}>
      {children}
    </MobileDetectionContext.Provider>
  );
};

export const useMobileDetection = (): CentralizedMobileDetection => {
  const context = useContext(MobileDetectionContext);
  if (context === undefined) {
    throw new Error('useMobileDetection must be used within a MobileDetectionProvider');
  }
  return context;
};